import { lazy } from 'react';

const SchoolsModal = lazy(() =>
  import('modules/WouldYouRather/modals/SchoolsModal'),
);

export default {
  WYR_SCHOOLS_MODAL: SchoolsModal,
};
